import React, { Component } from "react"

class OrderBar extends Component {
    closeModal() {
        const modal = document.getElementById("delivery-modal")
        modal.classList.remove("delivery-modal--open")
    }

    openModal() {
        const modal = document.getElementById("delivery-modal")
        modal.classList.add("delivery-modal--open")
    }

    render() {
        const { deliveryService, toast } = this.props.data

        return (
            <>
                <div className="order-bar">
                    <svg
                        preserveAspectRatio="none"
                        className="order-bar__wave"
                        viewBox="0 0 1440 36"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <defs>
                            <linearGradient
                                id="grad1"
                                x1="0%"
                                y1="0%"
                                x2="100%"
                                y2="0%"
                            >
                                <stop
                                    offset="0%"
                                    stopColor="#C62B37"
                                    stopOpacity="1"
                                />
                                <stop
                                    offset="100%"
                                    stopColor="#94212a"
                                    stopOpacity="1"
                                />
                            </linearGradient>
                        </defs>
                        <path
                            d="M0 15.63c86.77 6 195.55 9 326.36 9 196.2 0 708.76-23.3 935.98-24.63 51.46 0 110.68 1.26 177.66 3.79V36H0V15.63z"
                            fill="url(#grad1)"
                        />
                    </svg>
                    <div className="order-bar__btn-wrap site-width">
                        <button
                            type="button"
                            className="order-bar__title-btn"
                            tabIndex="-1"
                        >
                            Order Now
                        </button>
                        {toast && (
                            <a
                                href={toast}
                                rel="noopener noreferrer"
                                target="_blank"
                                className="order-bar__btn"
                            >
                                <svg
                                    viewBox="0 0 48 43"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g fill="#FFF" fillRule="nonzero">
                                        <path d="M47.73 26.14l-6.75-6.86a.93.93 0 0 0-.67-.28H19.1a.94.94 0 0 0-.93.95c0 .53.42.95.93.95h20.83l4.88 4.96H3.2l4.88-4.96h3.51c.52 0 .94-.42.94-.95a.94.94 0 0 0-.94-.95H7.7c-.25 0-.49.1-.67.28L.27 26.14a.96.96 0 0 0-.27.67v3.8c0 .15.03.28.08.4l5.07 11.43c.15.34.48.56.85.56h36c.37 0 .7-.22.85-.56L47.92 31a.96.96 0 0 0 .08-.4v-3.8c0-.26-.1-.5-.27-.67zm-1.6 1.62v1.9H1.87v-1.9h44.26zm-17.78 3.81l-.8 2.22a.1.1 0 0 1-.1.07h-6.9a.1.1 0 0 1-.1-.07l-.8-2.22h8.7zM41.4 41.1H6.61l-4.22-9.53h15.26l1.05 2.88c.28.79 1.03 1.31 1.85 1.31h6.9c.82 0 1.57-.52 1.85-1.3l1.06-2.89H45.6L41.4 41.1zM.94 6H45a3 3 0 0 0 0-6H.94A.94.94 0 0 0 0 .94v4.12c0 .52.42.94.94.94zm45.19-3c0 .62-.51 1.13-1.13 1.13H15.56V1.88H45c.62 0 1.13.5 1.13 1.12zM1.87 1.87H13.7v2.25H1.88V1.88zM45 8H.94a.94.94 0 0 0-.94.94v4.12c0 .52.42.94.94.94h17.43a.94.94 0 1 0 0-1.88h-2.8V9.88H45a1.13 1.13 0 0 1 0 2.24H25.87a.94.94 0 0 0 0 1.88H45a3 3 0 0 0 0-6zm-31.31 4.13H1.88V9.87h11.8v2.26z" />
                                        <path d="M22.7 13.7a1 1 0 0 0 0-1.4 1 1 0 0 0-1.4 0 1 1 0 0 0 0 1.4 1 1 0 0 0 1.4 0zM15.7 20.7A1 1 0 0 0 15 19a1 1 0 0 0-1 1 1 1 0 0 0 1.7.7z" />
                                    </g>
                                </svg>
                                <span>Rapid Pick-up</span>
                                <svg
                                    className="order-arrow"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M0 0h24v24h-24z" fill="none" />
                                    <path
                                        fill="white"
                                        d="M12 4l-1.41 1.41 5.58 5.59h-12.17v2h12.17l-5.58 5.59 1.41 1.41 8-8z"
                                    />
                                </svg>
                            </a>
                        )}
                        {deliveryService && (
                            <button
                                type="button"
                                className="order-bar__btn"
                                onClick={this.openModal}
                            >
                                <svg
                                    width="48"
                                    height="37"
                                    viewBox="0 0 48 37"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g fill="#FFF" fillRule="nonzero">
                                        <path d="M47.7260742 19.7753906l-7.8435059-7.862915c-.1761474-.1765137-.414917-.2753907-.6639404-.2753907H33.75V.9375C33.75.4196777 33.3303223 0 32.8125 0H.9375C.4196777 0 0 .4196777 0 .9375v11.8927002c0 .5178222.4196777.9375.9375.9375s.9375-.4196778.9375-.9375V5.7517089c.647461.4229737 1.420166.6701661 2.25.6701661 1.282837 0 2.430542-.588501 3.1875-1.5098877C8.069458 5.833374 9.217163 6.421875 10.5 6.421875c1.2828369 0 2.430542-.588501 3.1875-1.5098877.756958.9213867 1.9046631 1.5098877 3.1875 1.5098877s2.430542-.588501 3.1875-1.5098877c.756958.9213867 1.9046631 1.5098877 3.1875 1.5098877s2.430542-.588501 3.1875-1.5098877c.756958.9213867 1.9046631 1.5098877 3.1875 1.5098877.8298339 0 1.6025391-.2471924 2.25-.670166V29.625H20.3071289c-.8243408-1.3483886-2.3096924-2.25-4.0023193-2.25-1.5318604 0-2.8941651.7386474-3.75 1.8782959-.8562012-1.1396485-2.2181397-1.8782959-3.75-1.8782959-1.692627 0-3.1783448.9016114-4.0023194 2.25H1.875v-9.2947998c0-.5178223-.4196777-.9375-.9375-.9375s-.9375.4196777-.9375.9375V30.5625c0 .5178223.4196777.9375.9375.9375h3.2145996c-.0219726.1845703-.03479.3720703-.03479.5625 0 1.0543213.3500977 2.0284424.9400634 2.8125H.9375c-.5178223 0-.9375.4196777-.9375.9375s.4196777.9375.9375.9375h15.3673096c2.5847167 0 4.6875-2.1027833 4.6875-4.6875 0-.1904297-.0128174-.3779297-.0351563-.5625h14.3276368c-.0219727.1845703-.0347901.3720703-.0347901.5625 0 1.0543213.3500977 2.0284424.9400635 2.8125H27.84375c-.5178223 0-.9375.4196777-.9375.9375s.4196777.9375.9375.9375H39.9375c2.5847167 0 4.6875-2.1027833 4.6875-4.6875 0-.1904297-.0128174-.3779297-.0347901-.5625H47.0625c.5178223 0 .9375-.4196777.9375-.9375v-10.125c0-.2482911-.0985107-.4863281-.2739258-.6621094zM5.9923096 32.0625c0-1.5509033 1.2615967-2.8125 2.8125-2.8125s2.8125 1.2615967 2.8125 2.8125-1.2615967 2.8125-2.8125 2.8125c-1.5509034 0-2.8125-1.2615967-2.8125-2.8125zm10.3125 2.8125c-1.5509034 0-2.8125-1.2615967-2.8125-2.8125s1.2615966-2.8125 2.8125-2.8125c1.5509033 0 2.8125 1.2615967 2.8125 2.8125s-1.2615967 2.8125-2.8125 2.8125zM46.125 20.8253174V22.875h-6.9375c-.5170898 0-.9375-.4204102-.9375-.9375v-8.4254151h.5797119L46.125 20.8253174zm-42-16.2784424c-1.2407227 0-2.25-1.0092773-2.25-2.25V1.875h4.5v.421875c0 1.2407227-1.0092773 2.25-2.25 2.25zm6.375 0c-1.2407227 0-2.25-1.0092773-2.25-2.25V1.875h4.5v.421875c0 1.2407227-1.0092773 2.25-2.25 2.25zm6.375 0c-1.2407227 0-2.25-1.0092773-2.25-2.25V1.875h4.5v.421875c0 1.2407227-1.0092773 2.25-2.25 2.25zm6.375 0c-1.2407227 0-2.25-1.0092773-2.25-2.25V1.875h4.5v.421875c0 1.2407227-1.0092773 2.25-2.25 2.25zm6.375 0c-1.2407227 0-2.25-1.0092773-2.25-2.25V1.875h4.5v.421875c0 1.2407227-1.0092773 2.25-2.25 2.25zM39.9375 34.875c-1.5509033 0-2.8125-1.2615967-2.8125-2.8125s1.2615967-2.8125 2.8125-2.8125 2.8125 1.2615967 2.8125 2.8125-1.2615967 2.8125-2.8125 2.8125zm4.0023193-5.25c-.8239745-1.3483886-2.3096923-2.25-4.0023193-2.25-1.692627 0-3.1783447.9016114-4.0023193 2.25H33.75V13.5120849h2.625V21.9375c0 1.5509033 1.2615967 2.8125 2.8125 2.8125h6.9375v4.875h-2.1851807z" />
                                        <path d="M16.875 8.159912c-.5178223 0-.9375.420044-.9375.9375v.701294c-4.8889161.4658203-8.7436523 4.5329591-8.8718261 9.5115967-.4899903.0307618-.8781739.4365234-.8781739.9342041 0 2.5847169 2.1027832 4.6875 4.6875 4.6875h12c2.5847168 0 4.6875-2.1027831 4.6875-4.6875 0-.4976807-.3881836-.9038086-.8781739-.9342041-.1281738-4.9786376-3.98291-9.0457764-8.8718261-9.5115967v-.701294c0-.517456-.4196777-.9375-.9375-.9375zm6 14.8970948h-12c-1.2220459 0-2.2650146-.7833251-2.6517334-1.875h17.3034668c-.3867188 1.0916749-1.4296875 1.875-2.6517334 1.875zm1.9332276-3.75H8.9417724c.1373292-4.2568359 3.6430664-7.6783447 7.9332276-7.6783447s7.7958984 3.4215088 7.9332276 7.6783447z" />
                                    </g>
                                </svg>
                                <span>Delivery</span>
                                <svg
                                    className="order-arrow"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M0 0h24v24h-24z" fill="none" />
                                    <path
                                        fill="white"
                                        d="M12 4l-1.41 1.41 5.58 5.59h-12.17v2h12.17l-5.58 5.59 1.41 1.41 8-8z"
                                    />
                                </svg>
                            </button>
                        )}
                    </div>
                    <svg
                        preserveAspectRatio="none"
                        className="order-bar__wave-reverse"
                        viewBox="0 0 1440 36"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <defs>
                            <linearGradient
                                id="grad2"
                                x1="0%"
                                y1="0%"
                                x2="100%"
                                y2="0%"
                            >
                                <stop
                                    offset="0%"
                                    stopColor="#94212a"
                                    stopOpacity="1"
                                />
                                <stop
                                    offset="100%"
                                    stopColor="#C62B37"
                                    stopOpacity="1"
                                />
                            </linearGradient>
                        </defs>
                        <path
                            d="M0 15.63c86.77 6 195.55 9 326.36 9 196.2 0 708.76-23.3 935.98-24.63 51.46 0 110.68 1.26 177.66 3.79V36H0V15.63z"
                            fill="url(#grad2)"
                        />
                    </svg>
                </div>
            </>
        )
    }
}

export default OrderBar
